import { defaultColorPickerHex } from '@/components/ui/colorPicker';
import type { ItemType } from '@/lib/api/types/itemType';
import { ItemTypeIcons, type ItemTypeIconValue } from '@/lib/utils/common/itemTypeIcons';

export const ItemTypeIcon = ({
  className,
  itemType,
  'aria-hidden': ariaHidden,
}: {
  className?: string;
  itemType: ItemType;
  'aria-hidden'?: boolean | 'true' | 'false';
}) => {
  const IconComponent =
    ItemTypeIcons[itemType.icon as ItemTypeIconValue]?.icon || ItemTypeIcons.rocket.icon;
  const iconColor = itemType.color || defaultColorPickerHex;

  return (
    <IconComponent
      data-testid="item-type-icon"
      color={iconColor.startsWith('#') ? iconColor : `#${iconColor}`}
      className={className}
      aria-hidden={ariaHidden}
    />
  );
};
